import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Button, Modal, Table } from "semantic-ui-react";
import UiMeet3dEvent from "~/models/UiMeet3d/UiMeet3dEvent";
import ContentLoader from "~/components/element/ContentLoader";
import UiMeet3dEventTypeLabel from "./UiMeet3dEventTypeLabel";
import UiMeet3dEventDetailsFirstMove from "./UiMeet3dEventDetailsFirstMove";
import UiMeet3dEventType from "~/constants/UiMeet3d/UiMeet3dEventType";
import UiMeet3dEventDetailsLead from "./UiMeet3dEventDetailsLead";
import UiMeet3dEventNotificationItem from "./UiMeet3dEventNotificationItem";
import UiMeet3dEventDetailsMeetingRequest from "~/modules/UiMeet3d/components/UiMeet3dEventDetailsMeetingRequest";

@observer
class UiMeet3dEventDetailsModal extends Component {
  render() {
    const { open, onClose, isLoading, uiMeet3dEvent, t } = this.props;

    return (
      <Modal size="large" open={open} onClose={onClose}>
        <Modal.Header>{t("clientPanelMisc:eventDetails")}</Modal.Header>
        <Modal.Content>
          {isLoading || !uiMeet3dEvent ? (
            <ContentLoader />
          ) : (
            <Table definition>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>{t("clientPanelMisc:type")}</Table.Cell>
                  <Table.Cell>
                    <UiMeet3dEventTypeLabel type={uiMeet3dEvent.type} />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("clientPanelMisc:tour")}</Table.Cell>
                  <Table.Cell>{uiMeet3dEvent.tourId}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("date")}</Table.Cell>
                  <Table.Cell>{uiMeet3dEvent.creationDts.format("llll")}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("clientPanelMisc:content")}</Table.Cell>
                  <Table.Cell>
                    {uiMeet3dEvent.type === UiMeet3dEventType.FIRST_MOVE && (
                      <UiMeet3dEventDetailsFirstMove data={uiMeet3dEvent.data} />
                    )}
                    {uiMeet3dEvent.type === UiMeet3dEventType.LEAD && (
                      <UiMeet3dEventDetailsLead data={uiMeet3dEvent.data} />
                    )}
                    {uiMeet3dEvent.type === UiMeet3dEventType.MEETING_REQUEST && (
                      <UiMeet3dEventDetailsMeetingRequest data={uiMeet3dEvent.data} />
                    )}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("clientPanelMisc:notifications")}</Table.Cell>
                  <Table.Cell>
                    {uiMeet3dEvent.uiMeet3dEventNotifications.length === 0 && (
                      <p>{t("clientPanelMisc:noNotificationForEvent")}</p>
                    )}
                    {uiMeet3dEvent.uiMeet3dEventNotifications.length > 0 &&
                      uiMeet3dEvent.uiMeet3dEventNotifications.map(uiMeet3dEventNotification => (
                        <UiMeet3dEventNotificationItem
                          key={uiMeet3dEventNotification.id}
                          uiMeet3dEventNotification={uiMeet3dEventNotification}
                        />
                      ))}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>{t("close")}</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

UiMeet3dEventDetailsModal.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  uiMeet3dEvent: PropTypes.instanceOf(UiMeet3dEvent),
};

export default withTranslation()(UiMeet3dEventDetailsModal);
